import {BehaviorSubject} from 'rxjs';
import {IDataTalentSkill} from "../_interfaces/IDataTalentSkill";
import {IDataBloodmagicItem} from "../_interfaces/IDataBloodmagicItem";

interface InfoBloodmagicItem {
    popOpen: boolean
    popEl: Element | HTMLElement | null
    pop: IDataBloodmagicItem | null
}

const InfoBloodmagicItemBehaveSubscriber = new BehaviorSubject<InfoBloodmagicItem>({popOpen: false, popEl: null, pop: null});

export {
    InfoBloodmagicItemBehaveSubscriber
}
